import React, {useEffect, useRef} from 'react';
import ItemTypeForm from './ItemTypeForm';
import ItemAttributesForm from './ItemAttributesForm';
import { withStyles } from "@mui/styles";
import {Typography} from "@mui/material";

const styles = {
  column:{
    display:"flex",
    flexDirection:"column",
    gap: "1rem",
    width:"100%"
  },
  row:{
    display:"flex",
    flexWrap:"wrap",
    gap:"1rem",
    '& > *':{
      minWidth:'calc(min(14rem, 100%))',
      flex: 1
    }
  },
  errors:{
    backgroundColor: '#ffbdbd',
    padding: '4px 8px',
    borderRadius: '4px'
  },
  error:{
  },
};

function MindfileItemForm(props) {
  const { mindfileUserLevel, item, itemType, handleItemChange, keywordsList, peopleList, folderList, addFolder, validations, errors, classes } = props;
  const errorsRef = useRef(null);
  const nameLabel = itemType === "Link" ? "Url" : itemType === "Favorite" || itemType === "JournalPost" ? "Title" : "Name"
  const descriptionLabel = itemType === "JournalPost" ? "Post" : "Description";
  const validationMessages = {
    name:  `* ${nameLabel} is required.`,
    description:  `* ${descriptionLabel} is required.`,
    date:  "* Date is required.",
    emotion: "* Emotion is required.",
    beme: "* Beme is required.",
  };

  useEffect(() => {
    if(!errors || errors.length === 0 || !errorsRef.current){
      return;
    }
    errorsRef.current.scrollIntoView({behavior:"smooth"});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validations, errorsRef])

  return (
    <div className={classes.column}>
      {!errors || errors.length === 0 ? null :
        <Typography id="errorMessages" ref={errorsRef} component="div" color="textSecondary" gutterBottom className={classes.errors}>
          {errors.map((key) =>
            <div key={key} className={classes.error}>{validationMessages[key]}</div>
          )}
        </Typography>
      }
      <ItemTypeForm
        mindfileUserLevel={mindfileUserLevel}
        item={item}
        itemType={itemType || item.item_data_type}
        handleItemChange={handleItemChange}
        folderList={folderList}
        addFolder={addFolder}
        classes={classes}
        validations={validations}
      />
      <ItemAttributesForm
        item={item}
        itemType={itemType || item.item_data_type}
        handleItemChange={handleItemChange}
        keywordsList={keywordsList}
        peopleList={peopleList}
        folderList={folderList}
        addFolder={addFolder}
        classes={classes}
        validations={validations}
      />
    </div>
  );
}

export default withStyles(styles)(MindfileItemForm);
